import { PageRef } from 'providers/page-ref';

export type AdminUserPermissionsPageParams = {
  email?: string;
};

export const IAdminUserPermissionsPage: PageRef<AdminUserPermissionsPageParams, void> = {
  pageName: 'AdminUserPermissionsPage',
} as PageRef<AdminUserPermissionsPageParams, void>;
